import { render, staticRenderFns } from "./PromoGroup.vue?vue&type=template&id=0639d6e4"
import script from "./PromoGroup.vue?vue&type=script&lang=js"
export * from "./PromoGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports